export const scrollToTopHandler = () => {
    const anchor = document.querySelector('#feedback-message');
    if(anchor) {
      anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };